import { useQaResourcesStore as useChatResourcesStore } from '@/modules/AgenticChat/stores/useQaResourcesStore';
import { homepageRoute } from '@/modules/Homepage/route';
import { useQaResourcesStore } from '@/modules/Qa/stores/useQaResourcesStore';
import { useQaResourcesStore as useOldChatResourcesStore } from '@/modules/Qa/stores/useQaResourcesStore';
import { translationRoute } from '@/modules/Translation/route';
import { useTranslationResourcesStore } from '@/modules/Translation/stores/useTranslationResourcesStore';
import { useConfigStore } from '@/stores/useConfigStore';
import { NavigationGuard } from 'vue-router';

export async function withTranslationResources() {
  await useTranslationResourcesStore().getTranslationResources();
}

export function withQaUploadConfig() {
  useQaResourcesStore().getUploadConfig();
  useChatResourcesStore().getUploadConfig();
  useOldChatResourcesStore().getUploadConfig();
}

export async function withConfig() {
  const configStore = useConfigStore();
  if (!configStore.config) {
    await configStore.getConfig();
  }
}

export function redirectToTranslationRouteIfHomepageDisabled(
  homepageIsDisabled: boolean
): NavigationGuard {
  return (to) => {
    if (to.path === homepageRoute.path && homepageIsDisabled) {
      return { path: translationRoute.path };
    }
  };
}
